import Api from "../api/api";

export default async () => {
  return await Api.post("notification/delete-all");
};
